module.exports = __webpack_public_path__ + "img/100.b7f4f1aa.jpg";